<template>
  <!--QQ交流-->
  <el-popover placement="left" width="340" trigger="click"
              style="position: fixed; right: 0; top: 200px;z-index: 999">
    <div>
      <h3>产品销售</h3>
      <!--第一组-->
      <div style="display: flex">
        <!--华东-->
        <div style="display: flex">
          <div>华东大区：</div>
          <div>
            <a href="tencent://message/?uin=2856974120&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
        <!--华东-->
        <div style="display: flex;margin-left: 20px">
          <div>华南大区：</div>
          <div>
            <a href="tencent://message/?uin=3378015135&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
      </div>
      <!--第二组-->
      <div style="display: flex">
        <!--华中-->
        <div style="display: flex">
          <div>华中大区：</div>
          <div>
            <a href="tencent://message/?uin=3378015135&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
        <!--华北-->
        <div style="display: flex;margin-left: 20px">
          <div>华北大区：</div>
          <div>
            <a href="tencent://message/?uin=2856974120&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
      </div>
      <!--第三组-->
      <div style="display: flex">
        <!--西北-->
        <div style="display: flex">
          <div>西北大区：</div>
          <div>
            <a href="tencent://message/?uin=20423363&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
        <!--西南-->
        <div style="display: flex;margin-left: 20px">
          <div>西南大区：</div>
          <div>
            <a href="tencent://message/?uin=20423363&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
      </div>
      <!--第四组-->
      <div style="display: flex">
        <!--东北-->
        <div style="display: flex">
          <div>东北大区：</div>
          <div>
            <a href="tencent://message/?uin=1935840319&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
      </div>
      <h3>售后服务</h3>
      <!--第一组-->
      <div style="display: flex">
        <!--售后服务-->
        <div style="display: flex">
          <div>售后服务：</div>
          <div>
            <a href="tencent://message/?uin=2982930078&Site=&Menu=yes"><img src="@/assets/qq.jpg" alt=""></a>
          </div>
        </div>
      </div>
    </div>
    <el-button slot="reference" type="primary" style="width: 42px; height: 150px;">
    </el-button>
  </el-popover>
</template>

<script>
export default {
  name: 'QQtalk'
}
</script>

<style scoped>
.el-button--primary {
  background-color: #404040;
  border: 1px solid #808080;
  background-image: url('../assets/qqlogo.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
.el-button--primary:hover {
  background-color: #303030;
}
</style>
